// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Outfit-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Manrope-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Outfit';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: block;
}

@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: block;
}

.rescueally {
  --heading-font: 'Outfit', serif;
  --subheading-font: 'Manrope', sans-serif;
  --body-font: 'Manrope', sans-serif;
  --monospace-font: Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* begin structural style applications */
.rescueally {
  font-family: var(--body-font);
  /* Font Scaling from 320px - 480px */
  /* the bounds are set as rems so we are sized relative to the user's custom font size setting */
  font-size: clamp(0.88rem, 1.25vw + 0.63rem, 1rem);
  font-size: clamp(0.88rem, 1.25vi + 0.63rem, 1rem);
  font-weight: 200;
  color: black;
  --text-selection-color: #b0d3fa;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (prefers-color-scheme: dark) {
:not(.rescueally-light).rescueally {
    color: white;
}
  }
.rescueally-dark.rescueally {
    color: white;
}
.rescueally ::selection,.rescueally mark {
    background-color: var(--text-selection-color);
  }
.rescueally header,.rescueally h1,.rescueally h2,.rescueally h3,.rescueally h4 {
    text-rendering: optimizeLegibility;
  }
.rescueally h1,.rescueally h2 {
    font-family: var(--heading-font);
    font-weight: 700;
    margin: 1em 0 0.5em;
  }
@supports (-webkit-touch-callout: none) {
.rescueally h1,.rescueally h2 {
      letter-spacing: -0.05em;
      font-weight: 600;
  }
    }
.rescueally h1 small,.rescueally h2 small {
      letter-spacing: normal;
    }
.rescueally h1 {
    font-size: 1.8em;
  }
.rescueally h1 small {
      letter-spacing: normal;
      display: block;
      font-family: var(--subheading-font);
      font-size: 0.5em;
      font-weight: normal;
      opacity: 0.65;
      padding: 0 0.1em;
    }
.rescueally .h1-margin {
    margin: 1.8em 0 0.9em;
  }
.rescueally h2 {
    font-size: 1.5em;
    font-family: var(--subheading-font);
    font-weight: bold;
    margin: 0;
  }
.rescueally h2 small {
      text-transform: none;
      display: block;
      font-family: var(--body-font);
      font-size: 0.7em;
      font-weight: normal;
      opacity: 0.65;
    }
/* & h2 {
    font-family: var(--subheading-font);
    font-size: 1.5em;
    font-weight: normal;
    margin: 1em 0 1em;

    & small {
      display: block;
      margin-top: 0.3em;
      font-family: var(--heading-font);
      font-size: 0.8em;
      font-weight: normal;
      color: var(--color-blue-1);
    }
  } */
.rescueally h3 {
    font-family: var(--heading-font);
    font-size: 1.3em;
    font-weight: normal;
    margin: 1.3em 0 0.4em;
    position: relative;
    bottom: 0.1em;
  }
.rescueally h4 {
    font-family: var(--subheading-font);
    font-size: 0.9em;
    font-weight: normal;
    margin: 1.8em 0 0.5em;
  }
.rescueally img,.rescueally .wild-button,.rescueally a {
    -webkit-user-drag: none !important;
    -webkit-touch-callout: none !important;
    -webkit-tap-highlight-color: transparent !important;
  }
.rescueally p {
    margin: 0 0 0.65em;
  }
.rescueally b,.rescueally strong {
    font-weight: bolder;
  }
.rescueally code {
    font-family: var(--monospace-font);
  }
.rescueally hr {
    width: 100%;
    border: none;
    border-bottom: 1px solid var(--color-grey-4);
    opacity: 0.4;
    margin-bottom: 1.5em;
  }
@media (prefers-color-scheme: dark) {
:not(.rescueally-light).rescueally hr {
      border-bottom: 1px solid var(--color-grey-3);
  }
    }
.rescueally-dark.rescueally hr {
      border-bottom: 1px solid var(--color-grey-3);
  }
.rescueally h1 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h2 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h3 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h4 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h1 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h2 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h3 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally h4 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.rescueally a {
    color: currentColor;
    text-decoration: inherit;
  }

.rescueally.touch-only img,.rescueally.touch-only .wild-button,.rescueally.touch-only a {
    /* All of our interactions are accompanied by visible animations */
    outline: none !important;
  }
`, "",{"version":3,"sources":["webpack://./src/theme/typography.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4CAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4CAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,kCAAkC;EAClC,mEAAmE;AACrE;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,+FAA+F;EAC/F,iDAAiD;EAAjD,iDAAiD;EACjD,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;AAuJpC;AArJE;AAXF;IAYI,YAAY;AAoJhB;EAnJE;AAbF;IAYI,YAAY;AAoJhB;AAjJE;IAEE,6CAA6C;EAC/C;AAEA;IAKE,kCAAkC;EACpC;AAEA;IAEE,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;EAUrB;AARE;AANF;MAOI,uBAAuB;MACvB,gBAAgB;EAMpB;IALE;AAEA;MACE,sBAAsB;IACxB;AAGF;IACE,gBAAgB;EAWlB;AATE;MACE,sBAAsB;MACtB,cAAc;MACd,mCAAmC;MACnC,gBAAgB;MAChB,mBAAmB;MACnB,aAAa;MACb,gBAAgB;IAClB;AAGF;IACE,qBAAqB;EACvB;AAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;IACjB,SAAS;EAUX;AARE;MACE,oBAAoB;MACpB,cAAc;MACd,6BAA6B;MAC7B,gBAAgB;MAChB,mBAAmB;MACnB,aAAa;IACf;AAGF;;;;;;;;;;;;;;KAcG;AAEH;IACE,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;EACf;AAEA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;AAEA;IAGE,kCAAkC;IAClC,sCAAsC;IACtC,mDAAmD;EACrD;AAEA;IACE,kBAAkB;EACpB;AAEA;IAEE,mBAAmB;EACrB;AAEA;IACE,kCAAkC;EACpC;AAEA;IACE,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,YAAY;IACZ,oBAAoB;EAKtB;AAHE;AAPF;MAQI,4CAA4C;EAEhD;IADE;AATF;MAQI,4CAA4C;EAEhD;AAOI;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAIJ;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;AAIA;IAGE,kEAAkE;IAClE,wBAAwB;EAC1B","sourcesContent":["@font-face {\n  font-family: 'Outfit';\n  src: url('./fonts/Outfit-VariableFont_wght.ttf');\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Manrope';\n  src: url('./fonts/Manrope-VariableFont_wght.ttf');\n  font-display: block;\n}\n\n.rescueally {\n  --heading-font: 'Outfit', serif;\n  --subheading-font: 'Manrope', sans-serif;\n  --body-font: 'Manrope', sans-serif;\n  --monospace-font: Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* begin structural style applications */\n.rescueally {\n  font-family: var(--body-font);\n  /* Font Scaling from 320px - 480px */\n  /* the bounds are set as rems so we are sized relative to the user's custom font size setting */\n  font-size: clamp(0.88rem, 1.25vi + 0.63rem, 1rem);\n  font-weight: 200;\n  color: black;\n  --text-selection-color: #b0d3fa;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  @media (prefers-color-scheme: dark) {\n    color: white;\n  }\n\n  & ::selection,\n  mark {\n    background-color: var(--text-selection-color);\n  }\n\n  & header,\n  & h1,\n  & h2,\n  & h3,\n  & h4 {\n    text-rendering: optimizeLegibility;\n  }\n\n  & h1,\n  & h2 {\n    font-family: var(--heading-font);\n    font-weight: 700;\n    margin: 1em 0 0.5em;\n\n    @supports (-webkit-touch-callout: none) {\n      letter-spacing: -0.05em;\n      font-weight: 600;\n    }\n\n    & small {\n      letter-spacing: normal;\n    }\n  }\n\n  & h1 {\n    font-size: 1.8em;\n\n    & small {\n      letter-spacing: normal;\n      display: block;\n      font-family: var(--subheading-font);\n      font-size: 0.5em;\n      font-weight: normal;\n      opacity: 0.65;\n      padding: 0 0.1em;\n    }\n  }\n\n  .h1-margin {\n    margin: 1.8em 0 0.9em;\n  }\n\n  & h2 {\n    font-size: 1.5em;\n    font-family: var(--subheading-font);\n    font-weight: bold;\n    margin: 0;\n\n    & small {\n      text-transform: none;\n      display: block;\n      font-family: var(--body-font);\n      font-size: 0.7em;\n      font-weight: normal;\n      opacity: 0.65;\n    }\n  }\n\n  /* & h2 {\n    font-family: var(--subheading-font);\n    font-size: 1.5em;\n    font-weight: normal;\n    margin: 1em 0 1em;\n\n    & small {\n      display: block;\n      margin-top: 0.3em;\n      font-family: var(--heading-font);\n      font-size: 0.8em;\n      font-weight: normal;\n      color: var(--color-blue-1);\n    }\n  } */\n\n  & h3 {\n    font-family: var(--heading-font);\n    font-size: 1.3em;\n    font-weight: normal;\n    margin: 1.3em 0 0.4em;\n    position: relative;\n    bottom: 0.1em;\n  }\n\n  & h4 {\n    font-family: var(--subheading-font);\n    font-size: 0.9em;\n    font-weight: normal;\n    margin: 1.8em 0 0.5em;\n  }\n\n  & img,\n  & .wild-button,\n  & a {\n    -webkit-user-drag: none !important;\n    -webkit-touch-callout: none !important;\n    -webkit-tap-highlight-color: transparent !important;\n  }\n\n  & p {\n    margin: 0 0 0.65em;\n  }\n\n  & b,\n  & strong {\n    font-weight: bolder;\n  }\n\n  & code {\n    font-family: var(--monospace-font);\n  }\n\n  & hr {\n    width: 100%;\n    border: none;\n    border-bottom: 1px solid var(--color-grey-4);\n    opacity: 0.4;\n    margin-bottom: 1.5em;\n\n    @media (prefers-color-scheme: dark) {\n      border-bottom: 1px solid var(--color-grey-3);\n    }\n  }\n\n  & h1,\n  & h2,\n  & h3,\n  & h4 {\n    & mark {\n      &::before,\n      &::after {\n        font-size: 1.3em;\n        font-weight: normal;\n      }\n    }\n  }\n\n  & a {\n    color: currentColor;\n    text-decoration: inherit;\n  }\n}\n\n.rescueally.touch-only {\n  & img,\n  & .wild-button,\n  & a {\n    /* All of our interactions are accompanied by visible animations */\n    outline: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
